import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import './WalletModal.css';
import './ViewPaymentHistory.css';

import DatePickerCustom from '../../components/DatePicker/DatePicker';

import { format } from 'date-fns';
import axiosMain from '../../axiosMain';
import { BASE_URLS, URL_INVOICE_DOWNLOAD } from '../../utils/baseUrls';

// Bind modal to your appElement for accessibility
// Modal.setAppElement('#root');

const ViewPaymentHistory = ({ paymentModalIsOpen, handlePaymentModalClose, paymentData, handleDateChangeApply }) => {
  //   const [viewpaymentModalIsOpen, setViewpaymentModalIsOpen] = useState(false);
  console.log(paymentData, "paymentModalIsOpen");
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });


  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const paymentDataNew = Array.isArray(paymentData)
    ? paymentData.map((item, index) => ({
      id: index + 1, // Use index (1-based) as id
      ReferenceBy: item.ReferenceBy,
      ReferenceId: item.ReferenceId,
      ServiceName: item.ServiceName,
      TransactionDate: item.TransactionDate,
      CreditAmount: item.CreditAmount,
      DebitAmount: item.DebitAmount,
      AvailableBalance: item.AvailableBalance,
      InvoiceNumber: item.InvoiceNumber,
    }))
    : [];
  useEffect(() => {
    console.log("paymentDataNew", paymentDataNew)
    if (paymentDataNew.length > 0) {
      const totals = paymentDataNew.reduce(
        (acc, item) => ({
          CreditAmount: acc.CreditAmount + (Number(item.CreditAmount) || 0),
          DebitAmount: acc.DebitAmount + (Number(item.DebitAmount) || 0),
          AvailableBalance: acc.AvailableBalance + (Number(item.AvailableBalance) || 0),
        }),
        { CreditAmount: 0, DebitAmount: 0, AvailableBalance: 0 }
      );

      paymentDataNew.push({
        id: null,
        ReferenceBy: null,
        ReferenceId: null,
        ServiceName: null,
        TransactionDate: null,
        CreditAmount: totals.CreditAmount,
        DebitAmount: totals.DebitAmount,
        AvailableBalance: totals.AvailableBalance,
        InvoiceNumber: null,
      })
    }
  }, [paymentDataNew]);

  const formatDate = (rowData) => {
    try {

      if (rowData.TransactionDate !== null) {
        return format(new Date(rowData.TransactionDate), 'dd/MM/yyyy hh:mm:ss a');
      }
      else
        return null;
    } catch (error) {
      return rowData.TransactionDate; // Fallback to raw date if parsing fails
    }
  };


  const invoiceBodyTemplate = (rowData) => {
    const hasInvoice = rowData.InvoiceNumber !== null && rowData.InvoiceNumber !== '';
    if (!hasInvoice) return null; // optionally render nothing
    return (
      <Button
        label="Download"
        // icon="fa fa-download"
        className="p-button-sm p-button-text"
        disabled={!hasInvoice}
        onClick={async () => {
          try {
            const response = await axiosMain.post(
              URL_INVOICE_DOWNLOAD ,
              {
                InvoiceNumber: rowData.InvoiceNumber
              }
            );

            const base64Pdf = response?.data?.ResponseData?.[0]?.InvoicePdf;

            if (base64Pdf) {
              const byteCharacters = atob(base64Pdf);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });

              const blobUrl = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = `${rowData.InvoiceNumber}.pdf`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl); // clean up
            } else {
              alert('Failed to download invoice: No PDF found.');
            }
          } catch (error) {
            console.error('Invoice download error:', error);
            alert('An error occurred while downloading the invoice.');
          }
        }}
      > <i className='fa fa-download'></i></Button >
    );
  };


  const handleDateChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };
  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
  };
  const handleApply = async () => {
    console.log('Start Date:', startDate);
    console.log('End Date:', endDate);
    handleDateChangeApply(startDate, endDate);
  }
  return (
    <Modal className='transaction-date' size="xl" show={paymentModalIsOpen} onHide={() => handlePaymentModalClose} centered>
      <Modal.Header>
        <Button onClick={handlePaymentModalClose} className="modal-btn-close">
          <i className="fa fa-close"></i>
        </Button>
      </Modal.Header>
      <Modal.Body style={{ background: "transparent" }}>
        <DatePickerCustom startDate={startDate}
          endDate={endDate}
          onDateChange={handleDateChange}
          handleCancel={handleCancel}
          handleApply={handleApply} />
        <div>
          <DataTable value={paymentDataNew} removableSort>
            <Column field="id" header="#" />
            <Column className="ReferenceBy" field="ReferenceBy" sortable header="Reference By" />
            <Column className="ReferenceId" field="ReferenceId" sortable header="TID/TRID/BidderId" />
            <Column className="ServiceName" field="ServiceName" sortable header="Service" />
            <Column
              field="TransactionDate"
              sortable
              header="Transaction Date"
              body={formatDate}
            />
            <Column className="creditamount" field="CreditAmount" sortable header="Credit (Points)" />
            <Column className="DebitAmount" field="DebitAmount" sortable header="Debit (Points)" />
            <Column className="AvailableBalance" field="AvailableBalance" sortable header="Available (Points)" />
            <Column className="Invoice" field="Invoice" header="Invoice" body={invoiceBodyTemplate} />
          </DataTable>
        </div>

      </Modal.Body>
    </Modal>

  );
};

export default ViewPaymentHistory;